// 10問1セット×10セットのクイズデータ

export const quizSets = [
  {
    id: 1,
    title: "セット1: 神話と伝説の地（天孫降臨・天岩戸）",
    category: "神話・伝説",
    questions: [
      {
        id: 1,
        question: "日本神話において、天照大神（アマテラスオオミカミ）の命を受け、地上を治めるために高天原（たかまがはら）から降り立ったとされる孫神の名前は何でしょう？",
        options: [
          "瓊瓊杵命（ニニギノミコト）",
          "素戔嗚尊（スサノオノミコト）",
          "神武天皇（ジンムテンノウ）",
          "猿田毗古神（サルタビコノカミ）"
        ],
        correctAnswer: 0,
        explanation: "瓊瓊杵命（ニニギノミコト）は、天照大神の孫として高天原から地上に降り立った神です。"
      },
      {
        id: 2,
        question: "天孫降臨の際、ニニギノミコト一行を高千穂の峰まで道案内したとされる神の名前は何でしょう？",
        options: [
          "天鈿女命（アメノウズメノミコト）",
          "猿田毗古神（サルタビコノカミ）",
          "海幸彦（ウミサチヒコ）",
          "山幸彦（ヤマサチヒコ）"
        ],
        correctAnswer: 1,
        explanation: "猿田毗古神（サルタビコノカミ）は、天孫降臨の際に道案内を務めた神とされています。"
      },
      {
        id: 3,
        question: "ニニギノミコトが天照大神から授けられた三種の神器とは、八尺瓊勾玉（やさかにのまがたま）、八咫鏡（やたのかがみ）と、あと一つは何でしょう？",
        options: [
          "天逆鉾（あまのさかほこ）",
          "草薙剣（くさなぎのつるぎ）",
          "天叢雲剣（あめのむらくものつるぎ）",
          "布都御魂（ふつのみたま）"
        ],
        correctAnswer: 1,
        explanation: "草薙剣（くさなぎのつるぎ）は、三種の神器の一つです。"
      },
      {
        id: 4,
        question: "天孫降臨の地については、古くから二つの有力な候補地が「本家争い」を繰り広げてきました。宮崎県内にあるその二つの場所とは、西臼杵郡高千穂町と、もう一つはどこでしょう？",
        options: [
          "霧島連山の高千穂峰（たかちほのみね）",
          "都井岬（といみさき）",
          "えびの高原",
          "青島（あおしま）"
        ],
        correctAnswer: 0,
        explanation: "霧島連山の高千穂峰と高千穂町が、天孫降臨の地として古くから「本家争い」をしています。"
      },
      {
        id: 5,
        question: "霧島連山の高千穂峰の山頂に突き立てられている、天孫降臨の際にニニギノミコトが逆さに突き立てたという伝説が残る鉾（ほこ）の名前は何でしょう？",
        options: [
          "神武東征の鉾",
          "天叢雲剣",
          "天逆鉾（あまのさかほこ）",
          "草薙剣"
        ],
        correctAnswer: 2,
        explanation: "天逆鉾（あまのさかほこ）は、高千穂峰の山頂に突き立てられている伝説の鉾です。"
      },
      {
        id: 6,
        question: "弟である素戔嗚尊（スサノオノミコト）の乱暴に怒った天照大神が隠れてしまい、世界が闇に包まれたとされる伝説の洞窟の名前は何でしょう？",
        options: [
          "竜ヶ岩洞（りゅうがしどう）",
          "秋芳洞（あきよしどう）",
          "天岩戸（あまのいわと）",
          "龍泉洞（りゅうせんどう）"
        ],
        correctAnswer: 2,
        explanation: "天岩戸（あまのいわと）は、天照大神が隠れたとされる伝説の洞窟です。"
      },
      {
        id: 7,
        question: "天照大神が天岩戸に隠れた際、八百万（やおよろず）の神々が集まって対策を相談したとされる、高千穂町にある川沿いの洞窟の名前は何でしょう？",
        options: [
          "天安河原（あまのやすかわら）",
          "鵜戸神宮",
          "高千穂峡",
          "青島神社"
        ],
        correctAnswer: 0,
        explanation: "天安河原（あまのやすかわら）は、神々が集まって対策を相談した場所とされています。"
      },
      {
        id: 8,
        question: "天岩戸の前でユニークな舞を踊り、神々の笑いを誘って天照大神を外に誘い出すきっかけを作った芸能の女神の名前は何でしょう？",
        options: [
          "豊玉姫命（トヨタマヒメノミコト）",
          "木花咲耶姫（コノハナサクヤヒメ）",
          "天鈿女命（アメノウズメノミコト）",
          "磐長姫命（イワナガヒメノミコト）"
        ],
        correctAnswer: 2,
        explanation: "天鈿女命（アメノウズメノミコト）は、舞を踊って天照大神を誘い出すきっかけを作った女神です。"
      },
      {
        id: 9,
        question: "天安河原では、現在、訪れた人々が願いを込めて行うある風習が見られます。それは何でしょう？",
        options: [
          "絵馬を奉納する",
          "石を積むこと",
          "おみくじを結ぶ",
          "短冊を吊るす"
        ],
        correctAnswer: 1,
        explanation: "天安河原では、願いを込めて石を積む風習があります。"
      },
      {
        id: 10,
        question: "神話「海幸彦・山幸彦」の舞台の一つで、山幸彦（ヒコホホデミノミコト）が祀られ、縁結びの社として知られる宮崎市の島の名前は何でしょう？",
        options: [
          "幸島（こうじま）",
          "築島（つきしま）",
          "大島（おおしま）",
          "青島（あおしま）"
        ],
        correctAnswer: 3,
        explanation: "青島は、山幸彦が祀られる縁結びの社として知られています。"
      }
    ]
  },
  {
    id: 2,
    title: "セット2: 神話と伝説の地（海幸彦・山幸彦と神武東征）",
    category: "神話・伝説",
    questions: [
      {
        id: 11,
        question: "兄の釣り針を探して海神の宮（わたつみのみや）を訪れた山幸彦が、海神の娘・豊玉姫命（トヨタマヒメノミコト）と出会い、地上に戻ってトヨタマヒメが出産したとされる洞窟に本殿がある神社はどこでしょう？",
        options: [
          "宮崎神宮",
          "鵜戸神宮（うどじんぐう）",
          "高千穂神社",
          "江田神社"
        ],
        correctAnswer: 1,
        explanation: "鵜戸神宮（うどじんぐう）は、洞窟の中に本殿がある珍しい神社です。"
      },
      {
        id: 12,
        question: "山幸彦の孫であり、日本の初代天皇とされる神武天皇（カムヤマトイワレヒコノミコト）が、大和の地を目指して船団を率いて出発した「お舟出の地」として知られる港はどこでしょう？",
        options: [
          "油津（あぶらつ）港",
          "細島（ほそしま）港",
          "美々津（みみつ）港",
          "宮崎港"
        ],
        correctAnswer: 2,
        explanation: "美々津（みみつ）港は、神武天皇の東征の出発地とされています。"
      },
      {
        id: 13,
        question: "神武天皇の急な船出の際、人々が「おきよ、おきよ（起きろ、起きろ）」と声をかけ合って準備したという伝説に由来する、日向市美々津で今も行われている祭りの名前は何でしょう？",
        options: [
          "祇園祭",
          "おきよ祭り",
          "神武さま",
          "どんと祭"
        ],
        correctAnswer: 1,
        explanation: "おきよ祭りは、急な船出の際の「おきよ」の掛け声に由来する祭りです。"
      },
      {
        id: 14,
        question: "神武天皇の東征計画は、天皇が青年期を過ごした宮で練られたと伝えられています。その宮の跡とされる、現在の宮崎市の中心的な神社は何でしょう？",
        options: [
          "鵜戸神宮",
          "青島神社",
          "都農神社",
          "宮崎神宮"
        ],
        correctAnswer: 3,
        explanation: "宮崎神宮は、神武天皇が青年期を過ごした宮の跡とされています。"
      },
      {
        id: 15,
        question: "神武天皇のお舟出の際、急いで準備したため、あんと米粉の団子を一緒につき混ぜて作ったとされる美々津の郷土菓子は何でしょう？",
        options: [
          "つきいれだんご",
          "飫肥天（おびてん）",
          "かるかん",
          "破れ饅頭"
        ],
        correctAnswer: 0,
        explanation: "つきいれだんごは、急な準備の際に作られたとされる郷土菓子です。"
      },
      {
        id: 16,
        question: "高千穂峡の断崖絶壁は、約12万年前に起こったある山の巨大な噴火による火砕流が冷え固まり、五ヶ瀬川によって侵食されてできたものです。その山とは何でしょう？",
        options: [
          "桜島",
          "阿蘇山",
          "霧島山",
          "開聞岳"
        ],
        correctAnswer: 1,
        explanation: "阿蘇山の巨大噴火による火砕流が、高千穂峡の断崖を形成しました。"
      },
      {
        id: 17,
        question: "日本の滝百選にも選ばれている、高千穂峡のシンボルともいえる滝の名前は何でしょう？",
        options: [
          "関之尾滝（せきのおのたき）",
          "矢研の滝（やとぎのたき）",
          "真名井の滝（まないのたき）",
          "竜門の滝（りゅうもんのたき）"
        ],
        correctAnswer: 2,
        explanation: "真名井の滝（まないのたき）は、高千穂峡のシンボルとして知られています。"
      },
      {
        id: 18,
        question: "真名井の滝の落差は、およそ何メートルでしょう？",
        options: [
          "約17メートル",
          "約37メートル",
          "約57メートル",
          "約77メートル"
        ],
        correctAnswer: 0,
        explanation: "真名井の滝の落差は約17メートルです。"
      },
      {
        id: 19,
        question: "高千穂峡の柱状節理の断崖は、東西約何キロメートルにわたって続いているでしょう？",
        options: [
          "約1キロメートル",
          "約3キロメートル",
          "約7キロメートル",
          "約10キロメートル"
        ],
        correctAnswer: 2,
        explanation: "高千穂峡の柱状節理は、東西約7キロメートルにわたって続いています。"
      },
      {
        id: 20,
        question: "高千穂峡では、一つの場所から3本の橋が重なって見える全国的にも珍しい景観「三段橋」を見ることができます。下から順に、神橋、高千穂大橋と、一番上にかかる最も新しい橋の名前は何でしょう？",
        options: [
          "霧島大橋",
          "神都高千穂大橋（しんとたかちほおおはし）",
          "綾の照葉大吊橋",
          "五ヶ瀬大橋"
        ],
        correctAnswer: 1,
        explanation: "神都高千穂大橋（しんとたかちほおおはし）は、三段橋の最上部にかかる橋です。"
      }
    ]
  },
  {
    id: 3,
    title: "セット3: 壮大なる自然の造形美（青島・都井岬）",
    category: "自然",
    questions: [
      {
        id: 21,
        question: "高千穂神社に伝わる神話で、荒神・鬼八（きはち）が力自慢のために投げたとされる、推定重量200トンといわれる巨石の名前は何でしょう？",
        options: [
          "鬼八の力石（きはちのちからいし）",
          "鎮石（しずめいし）",
          "御腰掛岩（おこしかけいし）",
          "霊石亀石（れいせきかめいし）"
        ],
        correctAnswer: 0,
        explanation: "鬼八の力石（きはちのちからいし）は、推定重量200トンの巨石です。"
      },
      {
        id: 22,
        question: "青島をぐるりと囲む波状の奇岩「鬼の洗濯板」は、地質学的には、隆起した海底が波の浸食を受けてできた地形です。その正式名称は何でしょう？",
        options: [
          "柱状節理（ちゅうじょうせつり）",
          "隆起海床と奇形波蝕痕（りゅうきかいしょうときけいはしょくこん）",
          "カルスト地形",
          "リアス式海岸"
        ],
        correctAnswer: 1,
        explanation: "隆起海床と奇形波蝕痕（りゅうきかいしょうときけいはしょくこん）が正式名称です。"
      },
      {
        id: 23,
        question: "「鬼の洗濯板」の美しい縞模様は、硬さの違う2種類の地層が交互に重なっているために生まれます。その2種類の岩石とは、砂岩と何でしょう？",
        options: [
          "石灰岩",
          "花崗岩",
          "泥岩",
          "玄武岩"
        ],
        correctAnswer: 2,
        explanation: "砂岩と泥岩の硬さの違いが、美しい縞模様を生み出しています。"
      },
      {
        id: 24,
        question: "青島全体が国の特別天然記念物に指定されている理由の一つは、ある亜熱帯性の植物が4,000本以上も群生しているためです。その植物の名前は何でしょう？",
        options: [
          "ソテツ",
          "フェニックス",
          "ガジュマル",
          "ビロウ（ビロウジュ）"
        ],
        correctAnswer: 3,
        explanation: "ビロウ（ビロウジュ）が4,000本以上群生しており、国の特別天然記念物に指定されています。"
      },
      {
        id: 25,
        question: "青島はその貴重な亜熱帯性植物群落から、島全体が国のある特別な指定を受けています。それは何でしょう？",
        options: [
          "国の重要文化財",
          "国の名勝",
          "国の特別天然記念物",
          "世界自然遺産"
        ],
        correctAnswer: 2,
        explanation: "青島全体が国の特別天然記念物に指定されています。"
      },
      {
        id: 26,
        question: "宮崎県最南端の都井岬に生息し、国の天然記念物に指定されている野生馬の正式名称は何でしょう？",
        options: [
          "木曽馬",
          "与那国馬",
          "御崎馬（みさきうま）",
          "道産子"
        ],
        correctAnswer: 2,
        explanation: "御崎馬（みさきうま）は、都井岬に生息する国の天然記念物の野生馬です。"
      },
      {
        id: 27,
        question: "都井岬の御崎馬は、江戸時代にある藩が軍馬として放牧したのが始まりとされています。その藩とは何藩でしょう？",
        options: [
          "薩摩藩",
          "高鍋藩",
          "飫肥藩",
          "延岡藩"
        ],
        correctAnswer: 1,
        explanation: "高鍋藩が江戸時代に軍馬として放牧したのが始まりとされています。"
      },
      {
        id: 28,
        question: "都井岬の先端に立つ白亜の灯台は、九州地方にある灯台の中で唯一、ある特徴を持っています。それは何でしょう？",
        options: [
          "日本で最も古い",
          "内部を見学できること",
          "ソーラー発電で動いている",
          "レンガ造りである"
        ],
        correctAnswer: 1,
        explanation: "都井岬の灯台は、九州で唯一内部を見学できる灯台です。"
      },
      {
        id: 29,
        question: "都井岬で夏に行われる、村人を苦しめた大蛇を火攻めで退治したという伝説にちなんだ勇壮な祭りの名前は何でしょう？",
        options: [
          "祇園祭",
          "都井岬火まつり",
          "飫肥城下まつり",
          "おきよ祭り"
        ],
        correctAnswer: 1,
        explanation: "都井岬火まつりは、大蛇退治の伝説にちなんだ祭りです。"
      },
      {
        id: 30,
        question: "えびの高原という地名は、火山ガスの影響で、ある植物が「えび色」に染まる様子から名付けられたといわれています。その植物とは何でしょう？",
        options: [
          "ススキ",
          "ミヤマキリシマ",
          "カエデ",
          "ノカイドウ"
        ],
        correctAnswer: 0,
        explanation: "ススキが「えび色」に染まる様子から、えびの高原と名付けられました。"
      }
    ]
  },
  {
    id: 4,
    title: "セット4: 壮大なる自然の造形美（えびの高原・その他）",
    category: "自然",
    questions: [
      {
        id: 31,
        question: "4月下旬から5月にかけて白やピンクの可憐な花を咲かせる、世界中でえびの高原にのみ自生する国の天然記念物に指定された植物の名前は何でしょう？",
        options: [
          "ハマユウ",
          "ミヤマキリシマ",
          "ノカイドウ",
          "サクラ"
        ],
        correctAnswer: 2,
        explanation: "ノカイドウは、世界中でえびの高原にのみ自生する国の天然記念物です。"
      },
      {
        id: 32,
        question: "標高1,700メートルを誇り、霧島連山の最高峰である山の名前は何でしょう？",
        options: [
          "高千穂峰",
          "新燃岳",
          "韓国岳（からくにだけ）",
          "甑岳（こしきだけ）"
        ],
        correctAnswer: 2,
        explanation: "韓国岳（からくにだけ）は、標高1,700メートルの霧島連山の最高峰です。"
      },
      {
        id: 33,
        question: "えびの高原の初心者向けトレッキングコースとして人気の「池めぐりコース」では、主に3つの美しい火口湖を巡ります。その3つの池とは、白紫池（びゃくしいけ）、六観音御池（ろくかんのんみいけ）と、あと一つは何でしょう？",
        options: [
          "大浪池（おおなみいけ）",
          "御池（みいけ）",
          "不動池（ふどういけ）",
          "鰻池（うなぎいけ）"
        ],
        correctAnswer: 2,
        explanation: "不動池（ふどういけ）は、池めぐりコースで巡る3つの火口湖の一つです。"
      },
      {
        id: 34,
        question: "日向岬の先端に位置し、馬の背のように見えることからその名が付いた、高さ約70メートルの断崖絶壁の景勝地は何でしょう？",
        options: [
          "鵜戸千畳敷",
          "馬ヶ背（うまがせ）",
          "堀切峠",
          "猪崎鼻"
        ],
        correctAnswer: 1,
        explanation: "馬ヶ背（うまがせ）は、高さ約70メートルの断崖絶壁の景勝地です。"
      },
      {
        id: 35,
        question: "馬ヶ背の近くにある、岩礁が十字の形に見えることから名付けられた景勝地「クルスの海」。「クルス」とは、どの国の言葉で「十字架」を意味するでしょう？",
        options: [
          "英語",
          "スペイン語",
          "ポルトガル語",
          "オランダ語"
        ],
        correctAnswer: 2,
        explanation: "「クルス」はポルトガル語で「十字架」を意味します。"
      },
      {
        id: 36,
        question: "日本の滝百選にも選ばれている都城市の関之尾滝。その滝の上流には、世界有数の規模を誇る甌穴（おうけつ）群が広がっていますが、この「甌穴」とは何でしょう？",
        options: [
          "鍾乳洞のこと",
          "川底の石が水流で回転し、岩盤を削ってできた円形の穴",
          "火山の噴火によってできた窪地",
          "地震によってできた地割れ"
        ],
        correctAnswer: 1,
        explanation: "甌穴（おうけつ）は、川底の石が水流で回転し、岩盤を削ってできた円形の穴です。"
      },
      {
        id: 37,
        question: "3世紀末から7世紀にかけて造られた300基以上の古墳が集まる、日本最大級の古墳群として知られる西都市の遺跡の名前は何でしょう？",
        options: [
          "生目古墳群（いきめこふんぐん）",
          "西都原古墳群（さいとばるこふんぐん）",
          "本庄古墳群（ほんじょうこふんぐん）",
          "船塚古墳群（ふなづかこふんぐん）"
        ],
        correctAnswer: 1,
        explanation: "西都原古墳群（さいとばるこふんぐん）は、300基以上の古墳が集まる日本最大級の古墳群です。"
      },
      {
        id: 38,
        question: "西都原古墳群は、春になると約2,000本の桜と、ある黄色い花の絨毯とのコントラストが絶景として知られています。その黄色い花とは何でしょう？",
        options: [
          "ひまわり",
          "たんぽぽ",
          "菜の花",
          "コスモス"
        ],
        correctAnswer: 2,
        explanation: "西都原古墳群は、春に桜と菜の花のコントラストが美しい景勝地です。"
      },
      {
        id: 39,
        question: "戦国時代、日向国（現在の宮崎県）の覇権をめぐり、約100年にわたって激しい争いを繰り広げた二つの武家は何氏と何氏でしょう？",
        options: [
          "大友氏と龍造寺氏",
          "伊東氏と島津氏",
          "相良氏と阿蘇氏",
          "肝付氏と禰寝氏"
        ],
        correctAnswer: 1,
        explanation: "伊東氏と島津氏が、約100年にわたって日向国の覇権を争いました。"
      },
      {
        id: 40,
        question: "1572年、わずか300の兵で3,000の伊東軍を破ったとされる、島津義弘の劇的な勝利で知られる戦いは何でしょう？「九州の桶狭間」とも呼ばれます。",
        options: [
          "耳川の戦い",
          "沖田畷の戦い",
          "木崎原の戦い（きざきばるのたたかい）",
          "戸次川の戦い"
        ],
        correctAnswer: 2,
        explanation: "木崎原の戦い（きざきばるのたたかい）は、島津義弘の劇的な勝利で「九州の桶狭間」と呼ばれます。"
      }
    ]
  },
  {
    id: 5,
    title: "セット5: 歴史の舞台裏（伊東氏・島津氏・天正遣欧使節）",
    category: "歴史",
    questions: [
      {
        id: 41,
        question: "島津氏に日向を追われた伊東義祐の子で、豊臣秀吉の九州平定で功績を挙げ、初代飫肥藩主として大名に返り咲いた人物は誰でしょう？",
        options: [
          "伊東義益",
          "伊東祐兵（いとう すけたけ）",
          "伊東マンショ",
          "伊東祐安"
        ],
        correctAnswer: 1,
        explanation: "伊東祐兵（いとう すけたけ）は、初代飫肥藩主として大名に返り咲きました。"
      },
      {
        id: 42,
        question: "伊東氏の当主や一族の男性の名前に、代々共通して使われることが多い漢字一文字は何でしょう？",
        options: [
          "義",
          "忠",
          "祐（すけ）",
          "宗"
        ],
        correctAnswer: 2,
        explanation: "「祐（すけ）」は、伊東氏の一族の名前に代々使われる漢字です。"
      },
      {
        id: 43,
        question: "鎌倉時代に源頼朝から南九州最大の荘園を任されたことに始まる島津氏。その氏の名の由来となった荘園は、現在の宮崎県の何市を中心としていたでしょう？",
        options: [
          "宮崎市",
          "延岡市",
          "日南市",
          "都城市（みやこのじょうし）"
        ],
        correctAnswer: 3,
        explanation: "島津氏の名の由来となった荘園は、現在の都城市（みやこのじょうし）を中心としていました。"
      },
      {
        id: 44,
        question: "1582年にローマへ派遣された天正遣欧少年使節団の主席正使を務めた、伊東氏の一族のキリシタン少年は誰でしょう？",
        options: [
          "中浦ジュリアン",
          "原マルティノ",
          "千々石ミゲル",
          "伊東マンショ"
        ],
        correctAnswer: 3,
        explanation: "伊東マンショは、天正遣欧少年使節団の主席正使を務めました。"
      },
      {
        id: 45,
        question: "国富町にある法華嶽薬師寺（ほけだけやくしじ）には、伊東マンショの父が奉納した天井板が残っています。そこに記されていたマンショの幼名は何でしょう？",
        options: [
          "虎千代麿（とらちよまろ）",
          "松千代麿（まつちよまろ）",
          "竹千代麿（たけちよまろ）",
          "梅千代麿（うめちよまろ）"
        ],
        correctAnswer: 0,
        explanation: "伊東マンショの幼名は、虎千代麿（とらちよまろ）でした。"
      },
      {
        id: 46,
        question: "今や全国的な人気を誇る宮崎のソウルフード「チキン南蛮」が誕生したとされる都市はどこでしょう？",
        options: [
          "宮崎市",
          "都城市",
          "延岡市",
          "日南市"
        ],
        correctAnswer: 2,
        explanation: "チキン南蛮は、延岡市で誕生したとされています。"
      },
      {
        id: 47,
        question: "チキン南蛮には、甘酢ダレのみのシンプルなものと、その上にあるソースをかけたものの2つの系統があります。全国的に定番となったそのソースとは何でしょう？",
        options: [
          "オーロラソース",
          "デミグラスソース",
          "ホワイトソース",
          "タルタルソース"
        ],
        correctAnswer: 3,
        explanation: "タルタルソースをかけたチキン南蛮が全国的に定番となりました。"
      },
      {
        id: 48,
        question: "焼いたアジなどの魚のほぐし身と味噌をすり合わせ、出汁で溶いて豆腐やきゅうりと共に冷たいままご飯にかけて食べる、宮崎の夏の代表的な郷土料理は何でしょう？",
        options: [
          "がね",
          "冷や汁（ひやじる）",
          "煮しめ",
          "魚ずし"
        ],
        correctAnswer: 1,
        explanation: "冷や汁（ひやじる）は、宮崎の夏の代表的な郷土料理です。"
      },
      {
        id: 49,
        question: "宮崎名物「地鶏の炭火焼き」の独特の黒い色と香ばしい風味は、調理中にあるものが燻されることによって生まれます。そのあるものとは何でしょう？",
        options: [
          "備長炭の煙",
          "鶏の脂が炭に落ちて立ち上る煙",
          "桜のチップの煙",
          "松の葉の煙"
        ],
        correctAnswer: 1,
        explanation: "鶏の脂が炭に落ちて立ち上る煙が、独特の風味を生み出します。"
      },
      {
        id: 50,
        question: "日南市飫肥地区の郷土料理で、魚のすり身に豆腐や黒砂糖、味噌などを混ぜて揚げた、ほんのり甘い天ぷらを何というでしょう？",
        options: [
          "がね",
          "さつま揚げ",
          "おび天",
          "じゃこ天"
        ],
        correctAnswer: 2,
        explanation: "おび天は、日南市飫肥地区の郷土料理です。"
      }
    ]
  },
  {
    id: 6,
    title: "セット6: 宮崎の恵み（郷土料理・宮崎牛）",
    category: "食文化",
    questions: [
      {
        id: 51,
        question: "宮崎市内の寿司店が発祥とされる、エビとレタスをマヨネーズ味の酢飯で巻いた、サラダ巻きの元祖ともいわれる寿司は何でしょう？",
        options: [
          "カリフォルニアロール",
          "恵方巻",
          "レタス巻き",
          "鉄火巻き"
        ],
        correctAnswer: 2,
        explanation: "レタス巻きは、宮崎市内の寿司店が発祥とされています。"
      },
      {
        id: 52,
        question: "7月8日は「チキン南蛮の日」として記念日登録されています。その由来は何でしょう？",
        options: [
          "発明者の誕生日",
          "宮崎県の県民の日",
          "「なん(7)ばん(8)」の語呂合わせ",
          "初めてテレビで紹介された日"
        ],
        correctAnswer: 2,
        explanation: "「なん(7)ばん(8)」の語呂合わせから、7月8日がチキン南蛮の日になりました。"
      },
      {
        id: 53,
        question: "宮崎県内で生まれ育った黒毛和牛のうち、「宮崎牛」というブランドを名乗るためには、日本食肉格付協会の肉質等級で5段階中のいくつ以上と格付けされる必要があるでしょう？",
        options: [
          "2等級以上",
          "3等級以上",
          "4等級以上",
          "5等級のみ"
        ],
        correctAnswer: 2,
        explanation: "宮崎牛は、4等級以上の格付けが必要です。"
      },
      {
        id: 54,
        question: "「和牛のオリンピック」とも呼ばれる全国和牛能力共進会で、宮崎牛は最高賞である内閣総理大臣賞を4大会連続で受賞するという前人未到の快挙を成し遂げています。この大会は何年に一度開催されるでしょう？",
        options: [
          "2年に一度",
          "4年に一度",
          "5年に一度",
          "10年に一度"
        ],
        correctAnswer: 2,
        explanation: "全国和牛能力共進会は、5年に一度開催されます。"
      },
      {
        id: 55,
        question: "宮崎の完熟マンゴーの最高級ブランド「太陽のタマゴ」。その厳しい基準の一つである糖度は、何パーセント以上と定められているでしょう？",
        options: [
          "12度以上",
          "15度以上",
          "18度以上",
          "20度以上"
        ],
        correctAnswer: 1,
        explanation: "太陽のタマゴの糖度基準は、15度以上です。"
      },
      {
        id: 56,
        question: "「太陽のタマゴ」として出荷されるマンゴーは、収穫方法に大きな特徴があります。それはどのような方法でしょう？",
        options: [
          "完熟する直前に手で収穫する",
          "樹の上で完熟し、自然に落果したものをネットで受け止めて収穫する",
          "専用の機械で一斉に収穫する",
          "青い状態で収穫し、追熟させる"
        ],
        correctAnswer: 1,
        explanation: "樹の上で完熟し、自然に落果したものをネットで受け止めて収穫します。"
      },
      {
        id: 57,
        question: "上の表によると、宮崎県が全国生産量の100%を占める特産の柑橘類は何でしょう？",
        options: [
          "日向夏",
          "キンカン",
          "ヘベス",
          "ライチ"
        ],
        correctAnswer: 2,
        explanation: "ヘベスは、宮崎県が全国生産量の100%を占める特産の柑橘類です。"
      },
      {
        id: 58,
        question: "宮崎県が生産量日本一を誇る柑橘「きんかん」。その中でも、糖度16度以上、直径2.8cm以上などの基準をクリアした完熟きんかんのブランド名は何でしょう？",
        options: [
          "ひなた",
          "たまたま",
          "たいよう",
          "みやざき"
        ],
        correctAnswer: 1,
        explanation: "たまたまは、厳しい基準をクリアした完熟きんかんのブランド名です。"
      },
      {
        id: 59,
        question: "完熟きんかん「たまたま」の中でも、さらに糖度18度以上、直径3.2cm以上という厳しい基準を満たした最高級品のブランド名は何でしょう？",
        options: [
          "たまたまゴールド",
          "たまたまプレミアム",
          "たまたまロイヤル",
          "たまたまエクセレント"
        ],
        correctAnswer: 3,
        explanation: "たまたまエクセレントは、最高級の完熟きんかんのブランド名です。"
      },
      {
        id: 60,
        question: "宮崎県原産の柑橘「日向夏」は、他の柑橘類とは異なる独特の食べ方をします。爽やかな酸味のある果肉と一緒に食べる、ほんのり甘みのある部分とはどこでしょう？",
        options: [
          "黄色い外皮の部分",
          "種の部分",
          "皮の内側の白いワタ（アルベド）の部分",
          "葉の部分"
        ],
        correctAnswer: 2,
        explanation: "日向夏は、皮の内側の白いワタ（アルベド）の部分を果肉と一緒に食べます。"
      }
    ]
  },
  {
    id: 7,
    title: "セット7: 宮崎の恵み（焼酎文化）",
    category: "食文化",
    questions: [
      {
        id: 61,
        question: "芋、麦、米、そばなど多彩な原料で造られる宮崎の本格焼酎。その出荷量は、2023酒造年度まで10年連続で日本一を誇っています。この「本格焼酎」とは、どのような製法で造られた焼酎を指すでしょう？",
        options: [
          "連続式蒸留器で蒸留した焼酎（甲類焼酎）",
          "単式蒸留器で蒸留した焼酎（乙類焼酎）",
          "複数の焼酎をブレンドした焼酎",
          "樽で長期間熟成させた焼酎"
        ],
        correctAnswer: 1,
        explanation: "本格焼酎は、単式蒸留器で蒸留した焼酎（乙類焼酎）を指します。"
      },
      {
        id: 62,
        question: "全国的な知名度を誇る霧島酒造の「黒霧島」。その主な原料となっている芋の品種は何でしょう？",
        options: [
          "安納芋（あんのういも）",
          "紅はるか",
          "コガネセンガン",
          "紫優（むらさきまさり）"
        ],
        correctAnswer: 2,
        explanation: "黒霧島の主な原料は、コガネセンガンという芋の品種です。"
      },
      {
        id: 63,
        question: "かつて酒税法で「乙類焼酎」と呼ばれていたものを、その伝統と品質をアピールするために「本格焼酎」と呼ぶことを提唱した人物は、宮崎県にあるどの酒造会社の二代目社長だったでしょう？",
        options: [
          "雲海酒造",
          "霧島酒造",
          "神楽酒造",
          "高千穂酒造"
        ],
        correctAnswer: 1,
        explanation: "霧島酒造の二代目社長が「本格焼酎」という呼称を提唱しました。"
      },
      {
        id: 64,
        question: "雲海酒造が製造する芋焼酎「木挽BLUE」は、日本名水百選にも選ばれた、宮崎県内のどの町の水を使って仕込まれているでしょう？",
        options: [
          "高千穂町",
          "綾町（あやちょう）",
          "日之影町",
          "五ヶ瀬町"
        ],
        correctAnswer: 1,
        explanation: "木挽BLUEは、綾町（あやちょう）の日本名水百選の水を使って仕込まれています。"
      },
      {
        id: 65,
        question: "毎年11月中旬から翌年2月にかけて、高千穂地方の各集落で徹夜で奉納される神楽を何と呼ぶでしょう？",
        options: [
          "高千穂の昼神楽",
          "高千穂の夜神楽（よかぐら）",
          "高千穂の朝神楽",
          "高千穂の里神楽"
        ],
        correctAnswer: 1,
        explanation: "高千穂の夜神楽（よかぐら）は、徹夜で奉納される伝統的な神楽です。"
      },
      {
        id: 66,
        question: "国の重要無形民俗文化財にも指定されている「高千穂の夜神楽」は、一晩かけて全部で何番の舞が奉納されるでしょう？",
        options: [
          "十二番",
          "二十四番",
          "三十三番",
          "四十八番"
        ],
        correctAnswer: 2,
        explanation: "高千穂の夜神楽は、一晩かけて三十三番の舞が奉納されます。"
      },
      {
        id: 67,
        question: "毎年10月下旬に開催される宮崎県最大のお祭り「宮崎神宮大祭」は、県民から親しみを込めて何と呼ばれているでしょう？",
        options: [
          "神武さま（じんむさま）",
          "天神さま",
          "祇園さん",
          "えびす講"
        ],
        correctAnswer: 0,
        explanation: "宮崎神宮大祭は、県民から「神武さま（じんむさま）」と親しみを込めて呼ばれています。"
      },
      {
        id: 68,
        question: "「神武さま」の御神幸行列で見られる「ミスシャンシャン馬」は、かつて新婚夫婦がある神社へお参りする風習を再現したものです。その神社とはどこでしょう？",
        options: [
          "宮崎神宮",
          "青島神社",
          "鵜戸神宮",
          "高千穂神社"
        ],
        correctAnswer: 2,
        explanation: "「ミスシャンシャン馬」は、鵜戸神宮へお参りする風習を再現したものです。"
      },
      {
        id: 69,
        question: "馬に乗った花嫁を花婿が手綱を引く「シャンシャン馬」。その名前の由来は何でしょう？",
        options: [
          "馬の歩く音から",
          "馬につけられた鈴が「シャンシャン」と鳴ることから",
          "花嫁の衣装が擦れる音から",
          "祭りの掛け声から"
        ],
        correctAnswer: 1,
        explanation: "馬につけられた鈴が「シャンシャン」と鳴ることから、その名が付きました。"
      },
      {
        id: 70,
        question: "綾町に江戸時代から伝わるひな祭りの風習で、長女の初節句に、木の枝や苔、草花など自然の素材を使って奥座敷に山や川の風景を再現する飾りのことを何というでしょう？",
        options: [
          "雛壇（ひなだん）",
          "雛山（ひなやま）",
          "雛流し（ひなながし）",
          "雛飾り（ひなまつり）"
        ],
        correctAnswer: 1,
        explanation: "雛山（ひなやま）は、綾町に江戸時代から伝わるひな祭りの風習です。"
      }
    ]
  },
  {
    id: 8,
    title: "セット8: 文化と暮らし（伝統工芸・宮崎弁）",
    category: "文化",
    questions: [
      {
        id: 71,
        question: "都城市は、ある武具の全国生産量の約9割を占める日本一の産地です。その武具とは何でしょう？",
        options: [
          "日本刀",
          "鎧兜（よろいかぶと）",
          "竹弓（都城大弓）",
          "木刀"
        ],
        correctAnswer: 2,
        explanation: "都城市は、竹弓（都城大弓）の全国生産量の約9割を占める日本一の産地です。"
      },
      {
        id: 72,
        question: "霧島山麓に自生するカシやイスノキを材料に作られる都城木刀は、全国生産量の大半を占めています。この木刀づくりが本格化したのはいつの時代からでしょう？",
        options: [
          "鎌倉時代",
          "江戸時代",
          "明治時代",
          "昭和時代"
        ],
        correctAnswer: 2,
        explanation: "都城木刀づくりは、明治時代から本格化しました。"
      },
      {
        id: 73,
        question: "日南市周辺で江戸時代から植林されてきた、樹脂を多く含み、水やシロアリに強いことから、古くは造船用の木材として重宝された宮崎県を代表する杉のブランド名は何でしょう？",
        options: [
          "吉野杉",
          "屋久杉",
          "秋田杉",
          "飫肥杉（おびすぎ）"
        ],
        correctAnswer: 3,
        explanation: "飫肥杉（おびすぎ）は、宮崎県を代表する杉のブランドです。"
      },
      {
        id: 74,
        question: "国の伝統的工芸品にも指定されている「本場大島紬」は、鹿児島県が主な産地として知られていますが、宮崎県内では何市で生産されているでしょう？",
        options: [
          "宮崎市",
          "延岡市",
          "都城市",
          "日向市"
        ],
        correctAnswer: 2,
        explanation: "本場大島紬は、宮崎県内では都城市で生産されています。"
      },
      {
        id: 75,
        question: "宮崎弁では「とても」「すごく」といった強調を表す言葉として、ある特徴的な方言が使われます。それは何でしょう？",
        options: [
          "ばり",
          "めっちゃ",
          "てげ",
          "なまら"
        ],
        correctAnswer: 2,
        explanation: "宮崎弁では「てげ」が「とても」「すごく」という意味で使われます。"
      },
      {
        id: 76,
        question: "「てげ」を2回繰り返した「てげてげ」は、「とても」とは全く違う意味になります。どのような意味でしょう？",
        options: [
          "「絶対に」",
          "「適当に」「ほどほどに」",
          "「少しだけ」",
          "「静かに」"
        ],
        correctAnswer: 1,
        explanation: "「てげてげ」は、「適当に」「ほどほどに」という意味になります。"
      },
      {
        id: 77,
        question: "「面倒くさい」「億劫だ」といった、独特の気だるさを表現する宮崎弁の代表的な言葉は何でしょう？",
        options: [
          "しんどい",
          "よだきい",
          "だるい",
          "きつい"
        ],
        correctAnswer: 1,
        explanation: "「よだきい」は、宮崎弁で「面倒くさい」「億劫だ」という意味です。"
      },
      {
        id: 78,
        question: "宮崎弁では「怖い」ことを何というでしょう？",
        options: [
          "こわい",
          "おっとろしい",
          "おじい",
          "びびる"
        ],
        correctAnswer: 2,
        explanation: "宮崎弁では「怖い」ことを「おじい」と言います。"
      },
      {
        id: 79,
        question: "宮崎弁は、標準語と異なり、言葉の音の高低で意味を区別しないという特徴があります。このようなアクセントのことを何アクセントというでしょう？",
        options: [
          "京阪式アクセント",
          "東京式アクセント",
          "特殊アクセント",
          "無アクセント"
        ],
        correctAnswer: 3,
        explanation: "宮崎弁は、無アクセントという特徴があります。"
      },
      {
        id: 80,
        question: "温暖な気候から、宮崎県は春季に多くのプロスポーツチームがトレーニングキャンプを行うことで知られています。特に盛んなそのスポーツとは何でしょう？",
        options: [
          "サッカー",
          "プロ野球",
          "ラグビー",
          "ゴルフ"
        ],
        correctAnswer: 1,
        explanation: "宮崎県は、プロ野球のキャンプ地として特に盛んです。"
      }
    ]
  },
  {
    id: 9,
    title: "セット9: 文化と暮らし（プロ野球キャンプ）",
    category: "文化",
    questions: [
      {
        id: 81,
        question: "1959年に宮崎県で春季キャンプを始め、その後の「キャンプブーム」の火付け役となった球団はどこでしょう？",
        options: [
          "阪神タイガース",
          "中日ドラゴンズ",
          "読売ジャイアンツ",
          "広島東洋カープ"
        ],
        correctAnswer: 2,
        explanation: "読売ジャイアンツが1959年に宮崎県で春季キャンプを始め、「キャンプブーム」の火付け役となりました。"
      },
      {
        id: 82,
        question: "2024年現在、読売ジャイアンツ、福岡ソフトバンクホークス、オリックス・バファローズ、埼玉西武ライオンズ、広島東洋カープが宮崎県でキャンプを行っていますが、このうち日南市でキャンプを行うのは2球団です。どこでしょう？",
        options: [
          "読売ジャイアンツと福岡ソフトバンクホークス",
          "広島東洋カープと埼玉西武ライオンズ",
          "オリックス・バファローズと読売ジャイアンツ",
          "福岡ソフトバンクホークスと広島東洋カープ"
        ],
        correctAnswer: 1,
        explanation: "日南市でキャンプを行うのは、広島東洋カープと埼玉西武ライオンズです。"
      },
      {
        id: 83,
        question: "日南市（旧飫肥藩）出身で、明治時代に外務大臣として日英同盟の締結や、日露戦争の講和条約であるポーツマス条約の調印に尽力した外交官は誰でしょう？",
        options: [
          "小村寿太郎（こむら じゅたろう）",
          "高木兼寛（たかぎ かねひろ）",
          "石井十次（いしい じゅうじ）",
          "若山牧水（わかやま ぼくすい）"
        ],
        correctAnswer: 0,
        explanation: "小村寿太郎（こむら じゅたろう）は、日英同盟の締結やポーツマス条約の調印に尽力しました。"
      },
      {
        id: 84,
        question: "宮崎市（旧高岡町）出身の海軍軍医で、食事の改善によって海軍の脚気（かっけ）を撲滅し、「ビタミンの父」と称される人物は誰でしょう？",
        options: [
          "小村寿太郎",
          "高木兼寛（たかぎ かねひろ）",
          "石井十次",
          "安井息軒"
        ],
        correctAnswer: 1,
        explanation: "高木兼寛（たかぎ かねひろ）は、「ビタミンの父」と称される海軍軍医です。"
      },
      {
        id: 85,
        question: "東臼杵郡（旧東郷町）出身で、旅と酒をこよなく愛し、自然をうたった多くの短歌を残した国民的歌人は誰でしょう？",
        options: [
          "石川啄木",
          "斎藤茂吉",
          "若山牧水（わかやま ぼくすい）",
          "与謝野晶子"
        ],
        correctAnswer: 2,
        explanation: "若山牧水（わかやま ぼくすい）は、旅と酒をこよなく愛した国民的歌人です。"
      },
      {
        id: 86,
        question: "日本で最初の孤児院「岡山孤児院」を設立し、「児童福祉の父」と呼ばれる、高鍋町出身の社会事業家は誰でしょう？",
        options: [
          "石井十次（いしい じゅうじ）",
          "津田梅子",
          "渋沢栄一",
          "野口英世"
        ],
        correctAnswer: 0,
        explanation: "石井十次（いしい じゅうじ）は、「児童福祉の父」と呼ばれる社会事業家です。"
      },
      {
        id: 87,
        question: "テレビドラマ『半沢直樹』や『真田丸』の主演で知られる、宮崎市出身の人気俳優は誰でしょう？",
        options: [
          "温水洋一",
          "堺雅人（さかい まさと）",
          "瑛太",
          "山田孝之"
        ],
        correctAnswer: 1,
        explanation: "堺雅人（さかい まさと）は、宮崎市出身の人気俳優です。"
      },
      {
        id: 88,
        question: "人気音楽デュオ「コブクロ」のメンバーで、ギターとボーカルを担当する宮崎市出身のミュージシャンは誰でしょう？",
        options: [
          "黒田俊介",
          "小渕健太郎（おぶち けんたろう）",
          "北川悠仁",
          "岩沢厚治"
        ],
        correctAnswer: 1,
        explanation: "小渕健太郎（おぶち けんたろう）は、コブクロのメンバーで宮崎市出身です。"
      },
      {
        id: 89,
        question: "「えびちゃん」の愛称で親しまれ、ファッションモデルとして一世を風靡した宮崎市出身のモデルは誰でしょう？",
        options: [
          "蛯原友里（えびはら ゆり）",
          "押切もえ",
          "山田優",
          "杏"
        ],
        correctAnswer: 0,
        explanation: "蛯原友里（えびはら ゆり）は、「えびちゃん」の愛称で親しまれたモデルです。"
      },
      {
        id: 90,
        question: "独特のキャラクターで知られる俳優の温水洋一さんの出身地は、宮崎県内の何市でしょう？",
        options: [
          "宮崎市",
          "延岡市",
          "都城市",
          "日南市"
        ],
        correctAnswer: 2,
        explanation: "温水洋一さんは、都城市の出身です。"
      }
    ]
  },
  {
    id: 10,
    title: "セット10: 宮崎を彩る人々（芸能人・スポーツ選手）",
    category: "人物",
    questions: [
      {
        id: 91,
        question: "歌手の今井美樹さん、お笑いコンビ「とろサーモン」の2人、俳優の堺雅人さん。この4組の有名人の出身高校には、ある共通点があります。それは何でしょう？",
        options: [
          "全員が同じ部活動に所属していた",
          "全員が宮崎西高等学校の出身である",
          "全員が宮崎日本大学高等学校の出身である",
          "全員が生徒会長を務めていた"
        ],
        correctAnswer: 2,
        explanation: "全員が宮崎日本大学高等学校の出身です。"
      },
      {
        id: 92,
        question: "映画『もののけ姫』の主題歌を歌い、カウンターテナー歌手として世界的に知られる米良美一さんの出身地は、宮崎県内の何市でしょう？",
        options: [
          "宮崎市",
          "西都市",
          "小林市",
          "日向市"
        ],
        correctAnswer: 1,
        explanation: "米良美一さんは、西都市の出身です。"
      },
      {
        id: 93,
        question: "「ひまわりの約束」などのヒット曲で知られるシンガーソングライターの秦基博さんの出身地は、宮崎県内の何市でしょう？",
        options: [
          "日南市",
          "宮崎市",
          "都城市",
          "延岡市"
        ],
        correctAnswer: 0,
        explanation: "秦基博さんは、日南市の出身です。"
      },
      {
        id: 94,
        question: "お笑いコンビ「おかずクラブ」のメンバーで、宮崎県警察の交通安全メッセージ動画にも出演したオカリナさんの出身地は、宮崎県内の何市でしょう？",
        options: [
          "宮崎市",
          "都城市",
          "延岡市",
          "西都市（旧西都町）"
        ],
        correctAnswer: 3,
        explanation: "オカリナさんは、西都市（旧西都町）の出身です。"
      },
      {
        id: 95,
        question: "日向市出身で、日本のプロ野球とメジャーリーグで活躍し、現在は東京ヤクルトスワローズに所属する外野手は誰でしょう？",
        options: [
          "青木宣親（あおき のりちか）",
          "寺原隼人",
          "武田翔太",
          "興梠慎三"
        ],
        correctAnswer: 0,
        explanation: "青木宣親（あおき のりちか）は、日向市出身の外野手です。"
      },
      {
        id: 96,
        question: "延岡市出身で、競泳選手としてオリンピックに4大会連続で出場し、メダルを獲得した選手は誰でしょう？",
        options: [
          "北島康介",
          "松田丈志（まつだ たけし）",
          "萩野公介",
          "瀬戸大也"
        ],
        correctAnswer: 1,
        explanation: "松田丈志（まつだ たけし）は、延岡市出身の競泳選手です。"
      },
      {
        id: 97,
        question: "都城市出身で、読売ジャイアンツの投手として活躍し、2023年のワールド・ベースボール・クラシック（WBC）では日本代表「侍ジャパン」のメンバーとして世界一に貢献した選手は誰でしょう？",
        options: [
          "山本由伸",
          "戸郷翔征（とごう しょうせい）",
          "佐々木朗希",
          "大谷翔平"
        ],
        correctAnswer: 1,
        explanation: "戸郷翔征（とごう しょうせい）は、都城市出身の投手です。"
      },
      {
        id: 98,
        question: "宮崎日本大学高等学校出身で、福岡ソフトバンクホークスのエースとして活躍する「九州のダルビッシュ」の異名をとった投手は誰でしょう？",
        options: [
          "東浜巨",
          "千賀滉大",
          "武田翔太（たけだ しょうた）",
          "甲斐拓也"
        ],
        correctAnswer: 2,
        explanation: "武田翔太（たけだ しょうた）は、「九州のダルビッシュ」の異名をとった投手です。"
      },
      {
        id: 99,
        question: "宮崎県は多くのプロゴルファーを輩出していますが、その中でも「日本女子プロゴルフ選手権」で2度の優勝を果たすなど、女子プロゴルフ界のレジェンドとして知られる選手は誰でしょう？",
        options: [
          "宮里藍",
          "渋野日向子",
          "大迫たつ子（おおさこ たつこ）",
          "岡本綾子"
        ],
        correctAnswer: 2,
        explanation: "大迫たつ子（おおさこ たつこ）は、女子プロゴルフ界のレジェンドです。"
      },
      {
        id: 100,
        question: "Jリーグの浦和レッズで長年活躍し、元日本代表でもある宮崎市出身のフォワードは誰でしょう？",
        options: [
          "大久保嘉人",
          "興梠慎三（こうろき しんぞう）",
          "岡崎慎司",
          "長友佑都"
        ],
        correctAnswer: 1,
        explanation: "興梠慎三（こうろき しんぞう）は、宮崎市出身の元日本代表フォワードです。"
      }
    ]
  }
];

// 全クイズデータを1つの配列にまとめたもの（既存のコードとの互換性のため）
export const allQuizData = quizSets.flatMap(set => set.questions);
